import { Link, Outlet, useLocation } from "react-router-dom";
import React from "react";

export function AppLayout() {
  let linkClass =
    "bg-blue-50 justify-center flex gap-3 rounded p-3 px-5 hover:bg-blue-100 cursor-pointer items-center font-medium flex gap-3 md:justify-center ";
  const location = useLocation();
  return (
    <div className={"h-full flex flex-col"}>
      <div className={"flex-grow overflow-auto"}>
        <Outlet />
      </div>
      <div className={"bg-white shadow-2xl flex gap-3 p-2"}>
        <Link
          className={
            linkClass.replace(
              location.pathname.includes("transaction") ? "bg-blue-50" : "xx",
              "bg-blue-200"
            ) + " flex-grow "
          }
          to={"/transactions"}
        >
          <div className={"md:text-2xl"}>
            <span className={"fa fa-building-columns"} />{" "}
          </div>
          <div className={"hidden md:block"}>Transactions</div>
        </Link>
        <Link
          className={
            linkClass.replace(
              location.pathname.includes("documents") ? "bg-blue-50" : "xx",
              "bg-blue-200"
            ) + " flex-grow"
          }
          to={"/documents"}
        >
          {" "}
          <div className={"md:text-2xl"}>
            <span className={"fa fa-file-invoice"} />{" "}
          </div>
          <div className={"hidden md:block"}>Documents</div>
        </Link>
        <Link
          className={
            linkClass.replace(
              location.pathname.includes("contacts") ? "bg-blue-50" : "xx",
              "bg-blue-200"
            ) + " flex-grow"
          }
          to={"/contacts"}
        >
          {" "}
          <div className={"md:text-2xl"}>
            <span className={"fa fa-address-book"} />{" "}
          </div>
          <div className={"hidden md:block"}>Contacts</div>
        </Link>
        <Link
          className={linkClass.replace(
            location.pathname.includes("settings") ? "bg-blue-50" : "xx",
            "bg-blue-200"
          )}
          to={"/settings"}
        >
          {" "}
          <div className={"md:text-2xl"}>
            <span className={"fa fa-cog"} />{" "}
          </div>
        </Link>
      </div>
    </div>
  );
}
